import type { Bundle } from '../types'

/**
 * Valeurs techniques du moteur traduites pour l'affichage.
 *
 * Les codes (OK, PROHIBITED, UNAUTHORISED_AGGREGATOR…) restent le vocabulaire
 * du serveur et des journaux ; l'interface n'en montre que la version lisible,
 * la valeur d'origine passant en info-bulle pour qui doit rapprocher d'un log.
 */
export const enums = {
  // Pays
  'country.SN': { fr: 'Sénégal', en: 'Senegal' },
  'country.CI': { fr: "Côte d'Ivoire", en: 'Côte d’Ivoire' },
  'country.ML': { fr: 'Mali', en: 'Mali' },
  'country.BF': { fr: 'Burkina Faso', en: 'Burkina Faso' },
  'country.GN': { fr: 'Guinée', en: 'Guinea' },
  'country.TG': { fr: 'Togo', en: 'Togo' },
  'country.BJ': { fr: 'Bénin', en: 'Benin' },
  'country.NE': { fr: 'Niger', en: 'Niger' },
  'country.CM': { fr: 'Cameroun', en: 'Cameroon' },
  'country.GH': { fr: 'Ghana', en: 'Ghana' },
  'country.FR': { fr: 'France', en: 'France' },
  'country.BE': { fr: 'Belgique', en: 'Belgium' },
  'country.CA': { fr: 'Canada', en: 'Canada' },
  'country.GA': { fr: 'Gabon', en: 'Gabon' },

  // Catégories de marchand
  'category.retail': { fr: 'Commerce', en: 'Retail' },
  'category.gaming': { fr: 'Jeux', en: 'Gambling' },
  'category.adult': { fr: 'Adulte', en: 'Adult' },
  'category.crypto': { fr: 'Crypto', en: 'Crypto' },
  'category.food': { fr: 'Alimentation', en: 'Food' },
  'category.travel': { fr: 'Voyage', en: 'Travel' },
  'category.telecom': { fr: 'Télécom', en: 'Telecoms' },
  'category.finance': { fr: 'Finance', en: 'Finance' },
  'category.education': { fr: 'Éducation', en: 'Education' },
  'category.health': { fr: 'Santé', en: 'Health' },
  'category.other': { fr: 'Autre', en: 'Other' },

  // Statut marchand
  'merchantStatus.ACTIVE': { fr: 'Actif', en: 'Active' },
  'merchantStatus.SUSPENDED': { fr: 'Suspendu', en: 'Suspended' },
  'merchantStatus.UNDER_REVIEW': { fr: 'En révision', en: 'Under review' },
  'merchantStatus.TERMINATED': { fr: 'Résilié', en: 'Terminated' },

  // Circuit de traitement
  'triage.NEW': { fr: 'Nouveau', en: 'New' },
  'triage.TO_REVIEW': { fr: 'À examiner', en: 'To review' },
  'triage.IN_REVIEW': { fr: 'En cours', en: 'In review' },
  'triage.CONFIRMED': { fr: 'Confirmé', en: 'Confirmed' },
  'triage.FALSE_POSITIVE': { fr: 'Faux positif', en: 'False positive' },
  'triage.ESCALATED': { fr: 'Escaladé', en: 'Escalated' },
  'triage.ARCHIVED': { fr: 'Archivé', en: 'Archived' },

  // Niveau de risque d'un rapport de crawl
  'risk.OK': { fr: 'Conforme', en: 'Compliant' },
  'risk.WARNING': { fr: 'À vérifier', en: 'To check' },
  'risk.CRITICAL': { fr: 'Critique', en: 'Critical' },

  // Action recommandée
  'action.PASS': { fr: 'Aucune action', en: 'No action' },
  'action.REVIEW': { fr: 'À examiner', en: 'To review' },
  'action.SUSPEND': { fr: 'Suspendre', en: 'Suspend' },
  'action.BLOCK': { fr: 'Bloquer', en: 'Block' },
  'action.TAKEDOWN': { fr: 'Retrait', en: 'Takedown' },

  // Niveau de suspicion d'une détection
  'suspicion.LOW': { fr: 'Faible', en: 'Low' },
  'suspicion.MEDIUM': { fr: 'Moyen', en: 'Medium' },
  'suspicion.HIGH': { fr: 'Élevé', en: 'High' },
  'suspicion.CRITICAL': { fr: 'Critique', en: 'Critical' },

  // Règles pays
  'rule.ALLOWED': { fr: 'Autorisé', en: 'Allowed' },
  'rule.CONDITIONAL': { fr: 'Sous condition', en: 'Conditional' },
  'rule.FLAGGED': { fr: 'Signalé', en: 'Flagged' },
  'rule.PROHIBITED': { fr: 'Interdit', en: 'Prohibited' },
  'rule.NA': { fr: 'Non défini', en: 'Not defined' },

  // Rôles
  'role.SUPERADMIN': { fr: 'Super admin', en: 'Super admin' },
  'role.OWNER': { fr: 'Propriétaire', en: 'Owner' },
  'role.ADMIN': { fr: 'Administrateur', en: 'Administrator' },
  'role.AGENT': { fr: 'Agent', en: 'Agent' },

  // Sens d'un test de paiement
  'testDirection.DEPOSIT': { fr: 'Dépôt', en: 'Deposit' },
  'testDirection.WITHDRAWAL': { fr: 'Retrait', en: 'Withdrawal' },
} satisfies Bundle
